import Bugsnag from '@bugsnag/js';
// import * as Sentry from '@sentry/vue';

class Log {
  logSDK = null;
  constructor(sdk) {
    this.logSDK = sdk;
  }
  setUser(config) {
    const { id, name } = config;
    console.log(id, name, config);
    this.logSDK.setUser(id, '', name);
  }
  setTags(tags) {
    this.logSDK.setTags(tags);
  }
  setLevel(level) {
    this.logSDK.setLevel(level);
  }
  captureException(e, otherMessage) {
    this.bugsnagNotify(e, otherMessage);
  }
  bugsnagNotify(e, otherMessage) {
    // const { context, tags, level } = otherMessage;
    // try {
    //   const errorMessage = e
    //     ? typeof e === 'string'
    //       ? new Error(e)
    //       : typeof e === 'object'
    //       ? new Error(JSON.stringify(e))
    //       : ''
    //     : '';
    //   const errorContext = context
    //     ? typeof context === 'string'
    //       ? context
    //       : typeof context === 'object'
    //       ? JSON.stringify(context)
    //       : ''
    //     : '';
    //   Bugsnag.notify(errorMessage, function(event) {
    //     if (level) {
    //       event.severity = level;
    //     }
    //     if (context) {
    //       event.context = errorContext;
    //     }
    //     if (tags) {
    //       event.addMetadata('tags', tags);
    //     }
    //   });
    // } catch (error) {}
  }
  // sentryNotify(e, otherMessage) {
  //   try {
  //     const { context, tags, level } = otherMessage;
  //     const errorMessage = e
  //       ? typeof e === 'string'
  //         ? new Error(e)
  //         : typeof e === 'object'
  //         ? new Error(JSON.stringify(e))
  //         : ''
  //       : '';
  //     const errorContext = context
  //       ? typeof context === 'string'
  //         ? context
  //         : typeof context === 'object'
  //         ? new Error(JSON.stringify(context))
  //         : ''
  //       : '';
  //     Sentry.captureException(errorMessage, scope => {
  //       scope.setTags(tags);
  //       // 設置上下文
  //       scope.setContext('response', {
  //         response: errorContext
  //       });
  //       // 設置事件的嚴重性
  //       scope.setLevel(level);
  //       return scope;
  //     });
  //   } catch (error) {}
  // }
}
const MyLog = new Log(Bugsnag);
export default MyLog;
